import { useEffect, useMemo, useState } from 'react';
import { Dialog } from '../ui/Dialog';
import { Button } from '../ui/Button';
import { useLanguageStore } from '../../stores/language-store';
import { t } from '../../i18n/translations';

interface VersionCommentDialogProps {
  open: boolean;
  onClose: () => void;
  comment?: string;
  onSave: (comment: string) => Promise<void> | void;
}

export function VersionCommentDialog({ open, onClose, comment, onSave }: VersionCommentDialogProps) {
  const language = useLanguageStore((s) => s.language);
  const initial = useMemo(() => comment ?? '', [comment]);
  const [value, setValue] = useState(initial);

  useEffect(() => {
    if (open) setValue(initial);
  }, [open, initial]);

  return (
    <Dialog open={open} onClose={onClose} title={t(language, 'viewComment')}>
      <div className="space-y-4">
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={t(language, 'versionCommentPlaceholder')}
          rows={5}
          className="w-full px-2 py-2 bg-surface border border-surface-lighter rounded text-xs text-text placeholder:text-text-muted focus:outline-none focus:border-accent resize-none"
        />
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onClose}>
            {language === 'ru' ? 'Закрыть' : 'Close'}
          </Button>
          <Button
            onClick={async () => {
              await onSave(value);
              onClose();
            }}
          >
            {t(language, 'saveComment')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

